import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface DataItem {
  culture: string;
  Чуйская: number;
  Баткенская: number;
  "Джалал-Абадская": number;
  Нарынская: number;
  Ошская: number;
  Таласская: number;
  "Ыссык-Кульская": number;
}

const data: DataItem[] = [
  {
    culture: "Овцы",
    Чуйская: 660049,
    Баткенская: 415756,
    "Джалал-Абадская": 919653,
    Нарынская: 1127887,
    Ошская: 1121452,
    Таласская: 565146,
    "Ыссык-Кульская": 917653,
  },
];

const Sheephart: React.FC = () => {
  return (
    // <>
    //   <h2>Данные по реализации зерна (тонн)</h2>
      <ResponsiveContainer width="50%" height={400}>
        <BarChart data={data} margin={{ top: 20, right: 10, left: 10, bottom: 5 }}>
          <XAxis dataKey="culture" padding={{ left: 0, right: 0 }} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Чуйская" fill="#8884d8" />
          <Bar dataKey="Баткенская" fill="#82ca9d" />
          <Bar dataKey="ДжалалАбадская" fill="#ffc658" />
          <Bar dataKey="Нарынская" fill="#d88484" />
          <Bar dataKey="Ошская" fill="#84d8a4" />
          <Bar dataKey="Таласская" fill="#d884d8" />
          <Bar dataKey="Ыссык-Кульская" fill="#d8d884" />
        </BarChart>
      </ResponsiveContainer>
    // {/* </> */}
  );
};

export default Sheephart;
